import React, { useState, useEffect } from 'react';
import FlagTheme from './imgs/flag-theme.svg';
import FlagGroupFree from './imgs/flag-groupfree.svg';
import FlagInbound from './imgs/flag-inbound.svg';
import FlagOutbound from './imgs/flag-outbound.svg';
import FlagElderly from './imgs/flag-elderly.svg';
import FlagSignature from './imgs/flag-signature.svg';
import FlagMiniTour from './imgs/flag-minitour.svg';
import styles from './style.module.scss';
import { I_Tag } from '@Redux/detail/Group/interfaces';

interface I_FlagData {
    [key: string]: { src: string; alt: string };
}
export interface I_Props {
    ProductType?: string;
    TagList?: I_Tag[];
    width?: number;
    height?: number;
}

const Flag: React.FC<I_Props> = ({ ProductType = '1', TagList, width = 80, height = 44 }) => {
    const tagData: I_FlagData = {
        '100': { src: FlagElderly, alt: '大人囝仔俱樂部' },
        '195': { src: FlagMiniTour, alt: '迷你小團' },
    };

    const flagData: I_FlagData = {
        '1': { src: FlagTheme, alt: '主題旅遊' },
        '2': { src: FlagOutbound, alt: '國外團體' },
        '3': { src: FlagInbound, alt: '台灣團體' },
        '4': { src: FlagGroupFree, alt: '團體自由行' },
        '5': { src: FlagSignature, alt: '璽品旅遊' },
    };

    const selectedTag = TagList?.sort((a, b) => a.TagNo - b.TagNo).find((tag) =>
        Object.keys(tagData).includes(tag.TagNo.toString())
    );

    const selectedFlag = selectedTag ? tagData[selectedTag.TagNo] : flagData[ProductType];

    return selectedFlag ? (
        <img 
            className={styles.flag} 
            src={selectedFlag.src} 
            alt={selectedFlag.alt} 
            width={width}
            height={height}
        />
    ) : null;
};

export default Flag;
